import { on } from "delegated-events";

export default {
  init: () => {
    on(
      "mouseenter",
      ".btn-text",
      (e) => {
        if (e.currentTarget.querySelector("path")) {
          e.currentTarget.querySelector("path").dispatchEvent(new Event("mouseover"));
        }
      },
      { capture: true },
    );

    on(
      "mouseleave",
      ".btn-text",
      (e) => {
        if (e.currentTarget.querySelector("path")) {
          e.currentTarget.querySelector("path").dispatchEvent(new Event("mouseout"));
        }
      },
      { capture: true },
    );
  },
};
